export default __webpack_public_path__ + "assets/5171cd288d303c3e920f2fc978bbe777.jpg";